import { render } from "./ContentComics.vue?vue&type=template&id=ee7ac176&scoped=true"
import script from "./ContentComics.vue?vue&type=script&lang=js"
export * from "./ContentComics.vue?vue&type=script&lang=js"

import "./ContentComics.vue?vue&type=style&index=0&id=ee7ac176&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee7ac176"]])

export default __exports__